/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpgradeStatusInfo } from './upgradeStatusInfo';


export interface HoldUpgradeResponse { 
    /**
     * Total Number of deployments updated
     */
    deployments_updated: number;
    /**
     * List of status a deployment
     */
    upgrade_status_info_list: Array<UpgradeStatusInfo>;
}

